import gsap from 'gsap'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const pillarsGridRevealAnimation = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const pillars = selector('[data-motion-pillar]')

  batchRevealAnimation({
    targets: pillars,
    reverse,
    stagger: {
      amount: 0.3
    }
  })
}
